import { render } from "./ParamInvoiceTaxRatePageList.vue?vue&type=template&id=48c6bfe0&scoped=true&ts=true"
import script from "./ParamInvoiceTaxRatePageList.vue?vue&type=script&lang=ts"
export * from "./ParamInvoiceTaxRatePageList.vue?vue&type=script&lang=ts"

import "./ParamInvoiceTaxRatePageList.vue?vue&type=style&index=0&id=48c6bfe0&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c6bfe0"]])

export default __exports__